const state = {
  list: [],
  category: {},
  edit_category: {}
};

const getters = {
  list: (state) => {
    return (state.list || []).map((x) => Object.assign(x, { popularity: x.popularity || {} }));
  },
  category: (state) => {
    return state.category || {};
  },
  edit_category: (state) => {
    return state.edit_category || {};
  }
};

const mutations = {
  SET_LIST(state, categories) {
    state.list = categories;
  },

  SET_CATEGORY(state, category) {
    if (!category.popularity) {
      category.popularity = { id: null };
    }
    state.category = category;
    state.edit_category = category;
    const index = state.list.findIndex((x) => x.id === category.id);
    if (index < 0) {
      state.list.push(category);
    }
  },
  EDIT_CATEGORY(state, item) {
    state.edit_category = item;
  },
  SET_NOTES(state, item) {
    if (state.category.id === item.referenceId) {
      this._vm.$set(state.category, 'designNotes', item.notes);
      this._vm.$set(state.edit_category, 'designNotes', item.notes);
    }
    const index = state.list.findIndex((x) => x.id === item.referenceId);
    if (index >= 0) {
      this._vm.$set(state.list[index], 'designNotes', item.notes);
    }
  }
};

const actions = {
  load({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('categories/getAll', filter)
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCategory({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`categories/get?id=${id}`)
        .then((response) => {
          commit('SET_CATEGORY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  edit({ commit }, item) {
    commit('EDIT_CATEGORY', item);
  },
  create({ commit }, item) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('categories/create', item)
        .then((response) => {
          commit('SET_CATEGORY', response.data);
          commit('lookup/ADD_CATEGORY', response.data, { root: true });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('categories/update', req)
        .then((response) => {
          commit('SET_CATEGORY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveDesignGroups({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`categories/saveDesignGroups?categoryId=${req.categoryId}`, req.designGroupIds)
        .then((response) => {
          commit('SET_CATEGORY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setLifestyleImage({ commit }, req) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', req.file);
      this._vm.$http
        .post(`categories/setLifestyleImage?categoryId=${req.categoryId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          commit('SET_CATEGORY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setPrintImage({ commit }, req) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', req.file);
      this._vm.$http
        .post(`categories/setPrintImage?categoryId=${req.categoryId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          commit('SET_CATEGORY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  savePopularity({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`categories/savePopularity?id=${req.id}&popularityId=${req.popularityId}`)
        .then((response) => {
          commit('SET_CATEGORY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
